var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGenderFemale = function SvgGenderFemale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 200 226",
    role: "img"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".gender-female_svg__st0{fill:#fc90a5}.gender-female_svg__st1{fill:#f58299}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.398 4.228c-35.3 0-63.9 28.6-63.9 63.9s28.6 63.9 63.9 63.9h53.6c5.7 0 10.3-4.6 10.3-10.3v-53.6c0-35.2-28.6-63.9-63.9-63.9",
    className: "gender-female_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185.298 66.328v33.9h4.5c1.1 0 2.3-.2 3.4-.5 1.5-.6 3.2-1.6 3.2-3.7 0-3.8-11.1-29.7-11.1-29.7",
    className: "gender-female_svg__st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.898 180.328h63.9l20.6-80.1h-63.9z",
    className: "gender-female_svg__st0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.198 225.828h131.1s4.2-73.7-55.9-73.7-75.2 73.7-75.2 73.7",
    className: "gender-female_svg__st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M249.3 3444.2c-5-25.4-41.5-28.3-41.5-28.3-14.7-2.1-29.1.4-40.4 3.7-18.5 5.4-34.6 17.2-44.3 33.8-23.3 39.6 2.5 78-32.4 116.1-42.1 46-23.8 70.4-23.8 70.4h30.8s-5.1-38 23.7-58.3 46.6 2.3 59.8-27.2-28.9-69.6 14.6-74c5-.5 10-1.3 14.9-2.5.2 0 43.6-8.4 38.6-33.7",
    style: {
      fill: "#db0d5c"
    },
    transform: "translate(-63.002 -3413.872)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.998 83.728c-3.2-6.1-9.5-9.9-16.4-9.6-12.1 0-12.7 21.3-.1 30.9s20.9 3.6 20.9 3.6z",
    className: "gender-female_svg__st0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142.198 132.128h-14.3l11.3 11.3z",
    className: "gender-female_svg__st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.2 3522.5s5.5-1.7 12.9-4.1c2.4 1.5 1.5 4.1 0 4.1z",
    style: {
      fill: "#f05e96"
    },
    transform: "translate(-63.002 -3413.872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.4 3522.5 12.9 5c1.8-1 1.3-4.4 0-5z",
    style: {
      fill: "#f876a8"
    },
    transform: "translate(-63.002 -3413.872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.6 3481.2c.6.1.9.6.9 1.2-.1.4-.3.7-.7.8l-9 3.3c-1.9.7-3.9 1.4-5.9 2.1-1.1.3-2.2.7-3.3 1-.6.1-1.1-.2-1.3-.7-.1-.4 0-.8.3-1 .9-.8 1.8-1.6 2.8-2.3 1.9-1.3 3.9-2.3 6-3.1s4.4-1.2 6.7-1.4c1.1-.2 2.3-.1 3.5.1",
    style: {
      fill: "#11003f"
    },
    transform: "translate(-63.002 -3413.872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.4 3496c-6.2 0-12.4-1-18.3-2.8",
    style: {
      fill: "#11003f",
      stroke: "#140049",
      strokeWidth: 2.879,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "translate(-63.002 -3413.872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 3495.5v-6.5",
    style: {
      fill: "none",
      stroke: "#140049",
      strokeWidth: 2.159,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "translate(-63.002 -3413.872)"
  }));
};
export default SvgGenderFemale;